import { CountModel, DeletedStatisticsModel, CompanyContractModel, StatisticsFilterDto } from "../statistics/StatisticsModel";
import { ErrorModel } from "../common/models/CommonModels";
import api from "../utils/api";
import { momentToString } from "../utils/dateUtilities";
import { Moment } from "moment";

export const getUnitCount = (filters: StatisticsFilterDto): Promise<CountModel | undefined> => {
    return getStatistics<CountModel>("api/statistics/units", filters);
}

export const getTruckCount = (filters: StatisticsFilterDto): Promise<CountModel | undefined> => {
    return getStatistics<CountModel>("api/statistics/trucks", filters);
}

export const getDeletedUnits = (filters: StatisticsFilterDto): Promise<DeletedStatisticsModel | undefined> => {
    return getStatistics<DeletedStatisticsModel>("api/statistics/removedunits", filters);
}

export const getDeletedTrucks = (filters: StatisticsFilterDto): Promise<DeletedStatisticsModel | undefined> => {
    return getStatistics<DeletedStatisticsModel>("api/statistics/removedtrucks", filters);
}

export const getUnitContracts = (filters: StatisticsFilterDto): Promise<CompanyContractModel[] | undefined> => {
    return getStatistics<CompanyContractModel[]>("api/statistics/contractedUnits", filters);
}

export const getTruckContracts = (filters: StatisticsFilterDto): Promise<CompanyContractModel[] | undefined> => {
    return getStatistics<CompanyContractModel[]>("api/statistics/contractedTrucks", filters);
}

const momentToDate = (date: Moment) => {
    return date.toISOString();
}

const filtersToQuery = (filters: StatisticsFilterDto): string => {
    let query: string = `?startTime=${momentToDate(filters.startTime)}&endTime=${momentToDate(filters.endTime)}`;
    if (filters.showOnlyOwnCompany) {
        query = query.concat(`&companyId=${filters.companyId}`);
    }

    return query;
}

export const getStatistics = <T>(key: string, filters: StatisticsFilterDto): Promise<T | undefined> => {

    const filtersQuery = filtersToQuery(filters);

    return api.get(key + filtersQuery).then(response => {
        if (response.status === 200) {
            return <T><unknown>response.data;
        }

        return undefined;
    });
}



// WEBPACK FOOTER //
// ./src/api/statisticsApi.ts